/**
 * @type {BD_CFG}
 */
const CONFIG = {
    restURL: window.CFG?.restURL ?? "",
    themeURL: window.CFG?.themeURL ?? "",
    firebase: window.CFG?.firebase ?? {
        key: "",
        auth_domain: "",
        database_url: "",
        auth_token: "",
        team_code: "",
    },
    game: window.CFG?.game ?? {
        id: "",
        region: "",
        isFinish: false,
        timeLeft: 0,
        cfgLimit: {
            is_using_timer: false,
            timeLimit: 0,
            notifications: [],
        },
        rooms: [],
        mainrooms: [],
        teamname: "",
        isPlayingOnline: false,
        is_leader: false,
        is_profile_completed: false,
        teamconnector: {
            categories: [],
            timer: 0,
        },
        game_prop: {
            disableTimer: false,
            singlePlayer: false,
        },
        randomizer: [],
        regions: [],
    },
    isAuth: window.CFG?.isAuth ?? 0,
    mainRoom: window.CFG?.mainRoom ?? "",
    nonce: window.CFG?.nonce ?? "",
    siteURL: window.CFG?.siteURL ?? "",
    user: window.CFG?.user ?? {
        id: 0,
        avatar: "",
        nickname: "",
        email: "",
    },
    avatarOptions: window.CFG?.avatarOptions ?? [],
    default_avatar: window.CFG.default_avatar ?? "",
    strings: {
        confirmLeave: window.CFG?.strings.confirmLeave ?? "",
        playerLeft: window.CFG?.strings.playerLeft ?? "",
        selectRegion: window.CFG?.strings.selectRegion ?? "",
        chooseTeamName: window.CFG?.strings.chooseTeamName ?? "",
        virtual: window.CFG?.strings.virtual ?? "",
        physical: window.CFG?.strings.physical ?? "",
        playerDragging: window.CFG?.strings.playerDragging ?? "",
        playerDisconnected: window.CFG?.strings.playerDisconnected ?? "",
        leaderOffline: window.CFG?.strings.leaderOffline ?? "",
    },
};

export default CONFIG;
